<template>
  <section
    :style="{ 'background-image': 'url(' + backgroundImageSrc + ')' }"
    class="top">
    <div class="top__box">
      <div class="top__box--left">
        <p>{{ textData[lang.key].top.text }}</p>
        <img
          class="top__box--left_logo"
          src="@/assets/img/img-logo.png">
        <AppLink/>
      </div>
      <div class="top__box--right">
        <img
          :src="appImageSrc"
          class="top__box--right_smartphone">
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import setting from '@/setting.js'
import AppLink from '@/components/molecules/AppLink'

export default {
  name: 'Home',
  components: {
    setting,
    mapGetters,
    AppLink
  },
  computed: {
    ...mapGetters(['textData', 'lang', 'mediaType']),
    backgroundImageSrc: function () {
      return require('@/assets/img/bk-top.png')
    },
    appImageSrc: function () {
      let imageSrc = ''
      // プリレンダリング時は処理しない
      if (!(window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerendering)) {
        if (this.mediaType === 'pc') {
          imageSrc = require('@/assets/img/img-top-app.png')
        } else if (this.mediaType === 'sp') {
          imageSrc = require('@/assets/img/img-top-app-sp.png')
        }
      }
      return imageSrc
    }
  },
  data () {
    return {
      setting
    }
  },
  methods: {
  },
  mounted () {
    if (window.innerWidth <= 959) {
      const element = document.querySelector('.top')
      element.style.height = window.innerHeight + 'px'
    }
  },
  created () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  activated () {
  }
}
</script>
<style lang="postcss" scoped>
@import '../../assets/css/mixins.css';
@import '../../assets/css/variables.css';

  .top {
    color: #FFFFFF;
    height: calc(100vh -80px);
    min-height: 600px;
    max-height: 720px;
    background: no-repeat center;
    background-size: cover;
    &__box {
      display: flex;
      position: relative;
      max-width: 850px;
      height: 100%;
      margin: 0 auto;
      padding-top: 60px;
      &--left {
        height: calc(100% - 60px);
        & p {
          width: 440px;
          height: 66px;
          font-size: 24px;
          line-height: 33px;
          text-align: center;
          white-space: pre-line;
          margin-top: 10px;
        }
        &_logo {
          display: block;
          width: auto;
          /* 要素の高さ - pタグの高さ -  AppLinkの高さ - pタグのpadding-top */
          height: calc(100% - 66px - 48px - 10px);
          /* max-width: 360px; */
          padding: 40px 0;
          margin: auto;
          box-sizing: border-box;
        }
      }
      &--right {
        position: absolute;
        right: 10px;
        bottom: 0;
        height: calc(100% - 60px);
        &_smartphone {
          width: auto;
          height: 100%
        }
      }
    }
  }
  #app.en .top p,
  #app.fr .top p,
  #app.es .top p {
    font-size: 20px;
    line-height: 26px;
  }
  @media (--breakPoint) {
    .top {
      height: 100vh;
      min-height: auto;
      max-height: 720px;
      &__box {
        height: 100%;
        padding-top: 50px;
        &--left {
          width: 100%;
          height: 60%;
          & p {
            width: 100%;
            height: 44px;
            font-size: 14px;
            line-height: 22px;
            margin-top: 5px;
          }
          &_logo {
            display: block;
            width: auto;
            /* 要素の高さ - pタグの高さ -  AppLinkの高さ - pタグのpadding-top */
            height: calc(100% - 44px - 36px - 5px);
            padding: 20px 0;
            margin: auto;
            box-sizing: border-box;
          }
        }
        &--right {
          position: absolute;
          right: 50%;
          transform: translateX(50%);
          bottom: 0;
          height: 35%;
          &_smartphone {
            width: auto;
            height: 100%
          }
        }
      }
    }
    #app.en .top p,
    #app.fr .top p,
    #app.es .top p {
      font-size: 12px;
      line-height: 22px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/Top.vue